export const formatPrice = (value: number): string => {
    return "€ " + (value / 100).toFixed(2).replaceAll(".", ",");
};

export const capitalize = (value: string): string =>
    String(value).charAt(0).toUpperCase() + String(value).slice(1);

export const cutoffString = (str: string, maxLength: number = 65): string => {
    if (str.length <= maxLength) {
        return str;
    }
    return str.substring(0, maxLength - 3) + "...";
};
